import { createContext, FC, ReactNode, useContext } from 'react';

import type { PageVariant } from './Page.types';

const PageVariantContext = createContext<PageVariant>('default');

export const PageVariantProvider: FC<{ value: PageVariant; children: ReactNode }> = ({ value, children }) => (
	<PageVariantContext.Provider value={value}>{children}</PageVariantContext.Provider>
);

export const usePageVariant = () => useContext(PageVariantContext);
